import { IQuoteExactInputQueryParams } from '@interfaces/queries/params/IQuoteExactInputQueryParams';
import { IQuoteExactInputOutput } from '@interfaces/queries/outputs/IQuoteExactInputOutput';
import { IBaseQuery } from '@interfaces/queries/IBaseQuery';
import { injectable, inject, singleton } from 'tsyringe';
import { QuoterContract } from '@contracts';
import { RPC } from '@providers';

/**
 * @title Quote Exact Input Query
 * @notice Gets a quote for an exact input swap
 * @dev This query interacts with the QuoterContract to get a quote for an exact input swap
 */
@injectable()
@singleton()
export class QuoteExactInputQuery
  implements IBaseQuery<IQuoteExactInputQueryParams, IQuoteExactInputOutput>
{
  constructor(
    @inject(RPC)
    private readonly rpc: RPC
  ) {}

  /**
   * @notice Executes the quote exact input query
   * @param params The parameters for getting the quote
   * @returns The quote data including amount out, price impact, and gas estimate
   */
  async execute(params: IQuoteExactInputQueryParams): Promise<IQuoteExactInputOutput> {
    const quoter = new QuoterContract(this.rpc);
    const [amountOut, sqrtPriceX96AfterList, initializedTicksCrossedList, gasEstimate] =
      await quoter.instance.quoteExactInput.staticCall(params.path, params.amountIn);

    return {
      amountOut,
      sqrtPriceX96AfterList,
      initializedTicksCrossedList,
      gasEstimate
    };
  }
}
